export default class Toast {

    /**
     * Constructor for custom toast message
     */
    constructor(name) {
        this.toastMessage = $('[data-toast="'+name+'"]');

        this.show();
    }

    /**
     * Function that shows toast message and hides it on timeout
     */
    show() {
        this.toastMessage.addClass('show');

        setTimeout(() => {
            this.toastMessage.removeClass('show');
        }, 5000);
    }
}